import { ITask } from "@rentiohq/shared-frontend/dist/types/task.types";
import { TaskDocumentsOverview } from "./TaskDocumentsOverview";

interface IProps {
  taskId: number;
  task?: ITask;
}

export const TaskDocumentsOverviewContainer = (props: IProps) => {
  const { taskId, task } = props;

  if (!task) {
    return null;
  }

  return <TaskDocumentsOverview taskId={taskId} task={task} />;
};
